import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ArrayHelper } from '@core/helpers/array.helper';
import { BudgetTypeEnum } from '@enums/BudgetType';
import { EstimateConfiguration } from '@interfaces/EstimateConfiguration';
import * as _ from 'lodash';
import { EstimateBudgetTypes } from '../estimate-budget-types/models/estimate-budget-types.model';
import { EstimateBudgetTypesEnum } from './models/estimate-buget-types.enum';

@Component({
  selector: 'pop-estimate-budget-types',
  templateUrl: './estimate-budget-types.component.html',
  styleUrls: ['./estimate-budget-types.component.less']
})
export class EstimateBudgetTypesComponent implements OnInit {
  public constructor() {}

  public budgetTypeItems = [
    EstimateBudgetTypesEnum.Time,
    EstimateBudgetTypesEnum.Expense,
    EstimateBudgetTypesEnum.InternalFee
  ];

  public EstimateBudgetTypesEnum = EstimateBudgetTypesEnum;

  @Input()
  public consentGranted = false;

  @Input()
  public disabled = false;

  @Input()
  public fixRem = false;

  @Input()
  public requireConsent = false;

  @Input()
  public settings: EstimateConfiguration;

  private _estimateBudgetTypes: EstimateBudgetTypes;
  @Input() public get estimateBudgetTypes() {
    return this._estimateBudgetTypes;
  }
  public set estimateBudgetTypes(value: EstimateBudgetTypes) {
    this._estimateBudgetTypes = value;
    this.emitChanges();
  }
  @Output() public estimateBudgetTypesChange = new EventEmitter<EstimateBudgetTypes>();

  public get isDetailed() {
    return this.estimateBudgetTypes?.selectedBudgetType === BudgetTypeEnum.Detailed;
  }

  private emitChanges = _.debounce(() => this._emitChanges(), 250);

  private _emitChanges() {
    this.estimateBudgetTypesChange.emit(this.estimateBudgetTypes);
  }

  public ngOnInit(): void {
    this.consentGranted = !this.requireConsent; //  if consent is not require consider it granted
    if (!this.settings.activateInternalFees) {
      ArrayHelper.removeItem(this.budgetTypeItems, EstimateBudgetTypesEnum.InternalFee);
    }
  }
}
